module.exports = __webpack_public_path__ + "Floorplan_1BR_Terrace.6a2df646.pdf";


//////////////////
// WEBPACK FOOTER
// ./client/download/Floorplan_1BR_Terrace.pdf
// module id = 472
// module chunks = 0